import { UseQueryOptions, useQuery } from '@tanstack/react-query'

import { getAutomatedChecksReport } from 'services/results'
import { ResultsQueryKeys } from 'services/results/queryKeys'
import type { GetAutomatedChecksReportResponse } from 'services/results/types'
import { ApiErrorResponse } from 'services/types'

interface UseGetAutomatedChecksReportParams {
  resultId: string
  jobId: string
  options?: Omit<UseQueryOptions<GetAutomatedChecksReportResponse, ApiErrorResponse>, 'queryKey' | 'queryFn'>
}

export const useGetAutomatedChecksReport = ({ resultId, jobId, options }: UseGetAutomatedChecksReportParams) => {
  return useQuery<GetAutomatedChecksReportResponse, ApiErrorResponse>({
    ...options,
    queryKey: ResultsQueryKeys.AutomatedChecksReport(resultId, jobId),
    queryFn: ({ signal }) => getAutomatedChecksReport(resultId, jobId, { signal }),
    enabled: !!resultId && !!jobId && options?.enabled !== false
  })
}
